<template>
  <div>
    <div class="pg-cab">
      <div class="col">
        <span class="tag">Motorista parceiro</span>
        <h1>Rode com a gente<br>na Grande SP.</h1>
        <p class="sub">
          Trabalhamos com motoristas parceiros e veículos agregados. Valor combinado
          antes da viagem, pagamento em até 10 dias úteis após a entrega confirmada.
        </p>
      </div>
    </div>

    <section class="sec">
      <div class="col grade">
        <div class="conteudo">
          <h2 class="sec-h2">Como é a parceria</h2>

          <div class="lista">
            <div
              v-for="(c, i) in CONDICOES"
              :key="c.t"
              class="item-num revela"
              :style="{ transitionDelay: (i * 0.07) + 's' }"
              v-revela
            >
              <div class="n">{{ i + 1 }}</div>
              <div>
                <h3>{{ c.t }}</h3>
                <p>{{ c.d }}</p>
              </div>
            </div>
          </div>

          <h2 class="sec-h2 mt">O que a gente pede</h2>
          <ul class="req">
            <li v-for="r in REQUISITOS" :key="r">{{ r }}</li>
          </ul>

          <div class="aviso">
            As regras completas de valor, prazo e repasse estão na
            <router-link to="/politica-de-repasse">Política de Repasse</router-link>.
          </div>
        </div>

        <aside class="lado">
          <div class="painel-lado painel-lado--destaque">
            <div class="painel-h">
              <b>Quero ser parceiro</b>
              <span class="selo"><i></i> aberto</span>
            </div>

            <template v-if="!enviado">
              <p class="intro">Conta pra gente como é a sua operação. Respondemos no WhatsApp.</p>

              <label class="f-lb" for="p-nome">Nome</label>
              <input id="p-nome" v-model="nome" class="f-inp" type="text" placeholder="Como podemos te chamar" />

              <label class="f-lb" for="p-fone">WhatsApp</label>
              <input id="p-fone" v-model="fone" class="f-inp" type="tel" placeholder="(00) 00000-0000" maxlength="15" @input="mascara" />

              <label class="f-lb" for="p-veic">Veículo</label>
              <input id="p-veic" v-model="veiculo" class="f-inp" type="text" placeholder="Ex: Fiorino, VUC, 3/4" />

              <label class="f-lb" for="p-reg">Região onde roda</label>
              <input id="p-reg" v-model="regiao" class="f-inp" type="text" placeholder="Ex: Zona Leste, Guarulhos, ABC" />

              <a :href="waParceiro" target="_blank" rel="noopener" class="btn btn--azul envio" @click="confirmar">
                <v-icon size="18">mdi-whatsapp</v-icon> Enviar pelo WhatsApp
              </a>
              <p class="obs">Abre o WhatsApp com a mensagem pronta. É só enviar.</p>
            </template>

            <div v-else class="ok">
              <div class="ok-ic">
                <svg viewBox="0 0 24 24" width="22" height="22">
                  <path d="M5 12.5l4.5 4.5L19 7.5" fill="none" stroke="currentColor"
                        stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <h3>Mensagem preparada</h3>
              <p>Se o WhatsApp não abriu, chame direto em {{ CONTATO.telefoneExibicao }}.</p>
              <button class="btn btn--fio" @click="enviado = false">Preencher de novo</button>
            </div>
          </div>

          <div class="painel-lado resumo">
            <div class="painel-h"><b>Resumo</b></div>
            <div class="dado-l"><span class="k">Pagamento</span><span class="v forte">até 10 dias úteis</span></div>
            <div class="dado-l"><span class="k">Forma</span><span class="v">PIX ou transferência</span></div>
            <div class="dado-l"><span class="k">Exclusividade</span><span class="v">não exigida</span></div>
            <div class="dado-l"><span class="k">Região</span><span class="v">Grande São Paulo</span></div>
          </div>
        </aside>
      </div>
    </section>

    <CtaSection />
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import CtaSection from '@/components/CtaSection.vue'
import { CONTATO, waLink } from '@/config/contato'

const CONDICOES = [
  { t: 'Valor combinado antes de sair', d: 'Você sabe quanto vai receber pelo frete antes de iniciar o deslocamento. O valor não muda depois, salvo alteração pedida pelo cliente durante a execução.' },
  { t: 'Pagamento em até 10 dias úteis', d: 'Contados da confirmação da entrega, por PIX ou transferência para conta de titularidade própria ou da PJ cadastrada.' },
  { t: 'Sem exclusividade', d: 'Você continua rodando para quem quiser. Acionamos conforme a demanda e a sua disponibilidade.' },
  { t: 'Frete que faz sentido pra sua rota', d: 'A alocação considera a região onde você já roda, o porte do veículo e o horário — não empurramos viagem inviável.' },
]

const REQUISITOS = [
  'CNH válida na categoria exigida pelo veículo',
  'Curso de transporte de produtos perigosos em dia, para quem quiser rodar esse tipo de frete',
  'Documento do veículo em dia',
  'Veículo em condição de uso e compatível com a carga',
  'Dados bancários de titularidade própria ou da PJ cadastrada',
  'Disponibilidade para rodar na Grande São Paulo',
]

const nome = ref(''); const fone = ref(''); const veiculo = ref(''); const regiao = ref('')
const enviado = ref(false)

function mascara() {
  let v = fone.value.replace(/\D/g, '').slice(0, 11)
  if (v.length <= 10) v = v.replace(/^(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3')
  else v = v.replace(/^(\d{2})(\d{5})(\d{0,4})/, '($1) $2-$3')
  fone.value = v
}
function confirmar() { setTimeout(() => { enviado.value = true }, 400) }

const waParceiro = computed(() => waLink(
  `Olá! Quero ser motorista parceiro.\n\nNome: ${nome.value}\nWhatsApp: ${fone.value}\nVeículo: ${veiculo.value}\nRegião: ${regiao.value}`
))
</script>

<style scoped>
.grade { display: grid; grid-template-columns: 1.35fr 1fr; gap: 56px; align-items: start; }
.lista { display: grid; gap: 14px; margin-top: 26px; }
.mt { margin-top: 52px; margin-bottom: 22px; }
.conteudo .sec-h2 { font-size: clamp(24px, 2.6vw, 32px); }

.lado { display: grid; gap: 18px; position: sticky; top: 100px; }
.intro { font-size: 13.5px; line-height: 1.55; color: var(--texto); margin-top: 16px; }
.envio { width: 100%; margin-top: 24px; }
.obs { margin-top: 11px; font-size: 12px; color: var(--texto-fraco); text-align: center; }

.resumo .dado-l:first-of-type { padding-top: 16px; }

.ok { text-align: center; padding: 22px 0 6px; }
.ok-ic {
  width: 48px; height: 48px; border-radius: 50%;
  margin: 0 auto 16px;
  display: flex; align-items: center; justify-content: center;
  background: rgba(31, 157, 99, .12); color: var(--verde);
}
.ok h3 { font-size: 19px; font-weight: 800; margin-bottom: 8px; }
.ok p { font-size: 14px; color: var(--texto); line-height: 1.6; margin-bottom: 20px; }

@media (max-width: 980px) {
  .grade { grid-template-columns: 1fr; gap: 38px; }
  .lado { position: static; }
}
</style>
